import React from 'react';
import { Typography } from '@mui/material';
import { CenteredContentContainer } from '../containers';

const NotFoundView: React.FC = () => {
    return (
        <CenteredContentContainer>
            <Typography variant="h1">404: The page you are looking for isn’t here</Typography>
            <Typography variant="subtitle2">
                You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation
            </Typography>
        </CenteredContentContainer>
    );
};

export default NotFoundView;
